(function () {

  'use strict';

  angular
      .module('eltazkara.social', []);

})();